import { toIndiaMobileWithCountryCode } from "./util";

const DEFAULT_MISSION_CONTROL_BASE_URL = "https://mission-control.garaaz.com";

const getMissionControlBaseUrl = (): string => {
  const fromEnv = process.env.REACT_APP_MISSION_CONTROL_URL?.trim();
  if (fromEnv) {
    return fromEnv.replace(/\/$/, "");
  }
  return DEFAULT_MISSION_CONTROL_BASE_URL;
};

export const getCustomerMissionControlUrl = (
  mobile?: string | null,
): string | null => {
  const mcMobile = toIndiaMobileWithCountryCode(mobile);
  if (!mcMobile) return null;
  return `${getMissionControlBaseUrl()}/customers/${mcMobile}/overview`;
};

export const getSupplierMissionControlUrl = (
  supplierId?: string | null,
): string | null => {
  if (!supplierId) return null;
  return `${getMissionControlBaseUrl()}/Suppliers/${supplierId}/overview`;
};

export const openMissionControlUrl = (url: string | null): void => {
  if (!url) return;
  window.open(url, "_blank", "noopener,noreferrer");
};
